interface Props {
  sx?: React.CSSProperties
}

const GradientLine = ({ sx = {} }: Props) => {
  return (
    <div style={{
      backgroundImage: 'linear-gradient(to right, #5EC8FF, #8B5CF6, #FF4FA3)',
      height: '3px',
      ...sx
    }} />
  );
}

export default GradientLine;